import { createSvgIcon } from "@mui/material";

const BarcodeScannerIcon = createSvgIcon(
  <path d="m1 4v4h2v-4h4v-2h-4c-1.1 0-2 .9-2 2zm4 12h-4v4c0 1.1.9 2 2 2h4v-2h-4v-4zm16 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-18h-4v2h4v4h2v-4c0-1.1-.9-2-2-2z M5 6v12h2v-12zm2.5 0v12h1v-12zm1.5 0v12h1v-12zm2.5 0v12h1v-12zm1.5 0v12h2v-12zm3.5 0v12h1v-12zm1.5 0v12h1v-12z" />,
  "BarcodeScannerIcon",
);

export default BarcodeScannerIcon;
